module.exports = __webpack_public_path__ + "img/targetpractice.161947ad.png";